const VoucherCard = ({ className = '', borderColor = '#E9E9E9', children }) => {
  return (
    <div
      aria-label="Voucher Discount Card"
      className={`relative border border-[${borderColor}] ${className} after:content-[''] after:inline-block after:h-[24px] after:w-[24px] after:absolute after:right-0 after:top-[50%] after:translate-x-1/2 after:-translate-y-1/2 after:bg-white after:rounded-full after:border after:border-l-${borderColor} after:border-t-0 after:border-r-0 after:border-b-0`}
    >
      {children}
    </div>
  );
};

export default VoucherCard;
